const getOrgRoot = () => `https://${window.__slab.ORG_HOST}`;

export default getOrgRoot;
